import { RemoteLoadPoints } from '../../../data/usecases/points/remote-load-points'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeLoadPointsBySlug = (teamId: string, gameUUID: string): RemoteLoadPoints => {
  return new RemoteLoadPoints(`/public/teams/${teamId}/points?game=${gameUUID}`, makeAxiosHttpClient())
}
